var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('moon-loader',{attrs:{"color":"#2D9CDB","size":_vm.size}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }